import { useState, useEffect } from 'react';
import { Mail } from 'lucide-react';
import { useAuth } from './AuthModule';

const API = process.env.REACT_APP_API_URL || '';

export default function MailsArea() {
  const { user } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!user?.id) {
      setUnreadCount(0);
      return;
    }
    const userIdStr = String(user.id).replace(/n$/, '');
    fetch(`${API}/api/direct-messages/unread-count/${encodeURIComponent(userIdStr)}`)
      .then((res) => (res.ok ? res.json() : Promise.reject()))
      .then((data) => {
        if (data && typeof data.count === 'number') {
          setUnreadCount(data.count);
        }
      })
      .catch(() => setUnreadCount(0));
  }, [user?.id]);

  return (
    <a
      href="/postilaatikko"
      className="Menu-block Menu-block-mails MailsArea"
      aria-label={unreadCount > 0 ? `Viestit, lukemattomia: ${unreadCount}` : 'viestit'}
      title="Viestit"
    >
      <Mail className="MailsArea-icon" size={22} strokeWidth={2} aria-hidden />
      {unreadCount > 0 && (
        <span className="MailsArea-badge" aria-label={`${unreadCount} lukematonta`}>
          {unreadCount}
        </span>
      )}
    </a>
  );
}
